import { render, staticRenderFns } from "./Grapes.vue?vue&type=template&id=e5561e14&scoped=true"
import script from "./Grapes.vue?vue&type=script&lang=js"
export * from "./Grapes.vue?vue&type=script&lang=js"
import style0 from "./Grapes.vue?vue&type=style&index=0&id=e5561e14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5561e14",
  null
  
)

export default component.exports